import type { FC } from "react";
import Tooltip from "../../molecules/Tooltip";
import { theme } from "../../../theme";
import { useTranslation } from "react-i18next";
import BodySmall from "../typography/BodySmall";
import styled from "styled-components";

interface Props {
  isExpanded: boolean;
  onClick: () => void;
  small?: boolean;
}

const CollapseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.50232 13.2645C7.34673 13.2525 10.1432 12.6716 10.7361 13.2645C11.329 13.8574 10.7481 16.6539 10.7361 17.4983M13.2685 6.49831C13.2565 7.34271 12.6756 10.1392 13.2685 10.7321C13.8614 11.325 16.6579 10.7441 17.5023 10.7321M20.9991 3L13.6103 10.3822M10.3691 13.6247L3 21.002"
      stroke="#0F5156"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const CollapseIconSmall = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.33488 8.84299C4.89782 8.83499 6.76213 8.44772 7.1574 8.84299C7.55267 9.23825 7.1654 11.1026 7.1574 11.6655M8.84567 4.33221C8.83767 4.89514 8.4504 6.75945 8.84567 7.15472C9.24093 7.54999 11.1053 7.16272 11.6682 7.15472M13.9994 2L9.07353 6.92145M6.91273 9.08312L2 14.0013"
      stroke="#0F5156"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ExpandIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5017 3.26621C17.3461 3.25421 20.1426 2.67328 20.7355 3.26621C21.3284 3.85913 20.7475 6.65559 20.7355 7.5M20.5077 3.49097L13.5039 10.4961"
      stroke="#515D5E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.26621 16.4986C3.25421 17.343 2.67328 20.1395 3.26621 20.7324C3.85913 21.3253 6.65559 20.7444 7.5 20.7324M10.5019 13.4961L3.49809 20.5012"
      stroke="#515D5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ExpandIconSmall = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9985 2.17747C11.5615 2.16947 13.4258 1.78219 13.8211 2.17747C14.2163 2.57275 13.8291 4.43706 13.8211 5M13.6692 2.32731L9 6.9974"
      stroke="#515D5E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.17747 11.0017C2.16947 11.5646 1.78219 13.4289 2.17747 13.8242C2.57275 14.2195 4.43706 13.8322 5 13.8242M7.00123 9L2.33206 13.6701"
      stroke="#515D5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ButtonContainer = styled.button`
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

const ExpandAndCollapse: FC<Props> = ({ isExpanded, onClick, small }) => {
  const { t } = useTranslation();
  return (
    <Tooltip
      content={
        <BodySmall color={theme.colors.white}>
          {isExpanded ? t("menu.collapse") : t("menu.expand")}
        </BodySmall>
      }
    >
      <ButtonContainer onClick={onClick}>
        {isExpanded ? (
          small ? (
            <CollapseIconSmall />
          ) : (
            <CollapseIcon />
          )
        ) : small ? (
          <ExpandIconSmall />
        ) : (
          <ExpandIcon />
        )}
      </ButtonContainer>
    </Tooltip>
  );
};

export default ExpandAndCollapse;
